import { listFiles } from './helpers'

export default class DatastoreTypeHandler {
  constructor(type) {
    this.type = type
  }

  emptyFileValue() {
    return null
  }

  fileRules() {
    return []
  }

  prepareFormData(data) {
    return data
  }

  applyTypeDefaults(data, set) {
    set('file', this.emptyFileValue())
  }

  validateCreate() {
    return { ok: true, errors: {} }
  }

  buildCreatePayload(data, context = {}) {
    return {
      name: data.name,
      type: this.type,
      workspace_id: context.workspace_id,
    }
  }

  buildUpdatePayload(data) {
    return { name: data.name }
  }

  fileState() {
    return null
  }

  selectedFiles(data) {
    return listFiles(data && data.file)
  }

  async inspectSelectedFiles() {
    return null
  }

  parseUploadMeta() {
    return {}
  }

  async afterUpload({ uploaded }) {
    return uploaded
  }

  appendUploadedFile(formData, index, item) {
    if (!item) return
    formData.append(`files[${index}][file_path]`, item.file_path)
    formData.append(`files[${index}][file_name]`, item.file_name)
  }
}
